import { useTranslation } from 'react-i18next';
import InvitationPage from '../../share/InvitationPage';

type QrcodeModalProps = {
  toggleModal: () => void;
  newInviteUrl: string | undefined;
};

export function QrcodeModal({ toggleModal, newInviteUrl }: QrcodeModalProps) {
  const [t] = useTranslation(['chatroom']);
  return (
    <div className="bg-white flex flex-col p-4 w-full">
      <span
        className="material-symbols-outlined text-manage-primary text text-end font-extrabold"
        onClick={toggleModal}
      >
        close
      </span>
      <div className="flex flex-col w-full h-full justify-center items-center gap-5">
        <span className="font-semibold text-xl text-center">
          {t('create_chatroom_share_title', '建立成功！來邀請組員吧！')}
        </span>
        <InvitationPage inviteUrl={newInviteUrl || ''} />
      </div>
    </div>
  );
}
